

export const environment = {
   host: {
       apiurl:'https://golestankooh.com/backend/public',
     api_key:'cumjtobhwnhtormbdlbeixxhbduxmycv'
   }

};


